module.exports = __webpack_public_path__ + "static/img/no-img.3bc4bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-img.jpg
// module id = Gazr
// module chunks = 3